import { ProtectedView } from "@/app/protected-view";
import { View3D } from "@/pages/3d-view";
import { Login } from "@/pages/login";
import { Planogram } from "@/pages/planogram";
import { Stores } from "@/pages/stores";
import { createBrowserRouter, Navigate } from "react-router-dom";

export const appRouter = () =>
  createBrowserRouter([
    {
      path: "/",
      element: <ProtectedView />,
      children: [
        {
          path: "/",
          element: <Navigate to="/stores" replace />,
        },
        {
          path: "/stores",
          element: <Stores />,
        },
        {
          path: "/stores/:storeKey",
          children: [
            {
              index: true,
              element: <Navigate to="3d-view" replace />,
            },
            {
              path: "3d-view",
              element: <View3D />,
            },
            {
              path: "planogram-2d",
              element: <Planogram />,
            },
          ],
        },
      ],
    },
    {
      path: "/login",
      element: <Login />,
    },
  ]);
